import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { User } from "oidc-client-ts";

const initialValue = undefined;

export const userAtom = atomWithStorage<User | undefined>(
  "user",
  initialValue,
  undefined,
  { getOnInit: true },
);

/**
 * V2 WorkOS auth state (INS-1393). In-memory only — meq_at + meq_rt
 * cookies on .meqinsights.com are the source of truth for the actual
 * session. This atom carries the SPA-facing user shape hydrated from
 * authkit-ui /api/session on boot.
 *
 * `authGen` is bumped by V3's silent refresh to invalidate in-flight
 * queries after a token rotation. Stays at 0 in V2.
 *
 * `expiresAt` is reserved for V3 (silent refresh derives the timer
 * from this); /api/session does not return it today, so V2 leaves
 * it null.
 */
export interface WorkosAuthState {
  user: { id: string } | null;
  orgId: string | null;
  csrfToken: string | null;
  authGen: number;
  expiresAt: number | null;
}

export const workosAuthInitialState: WorkosAuthState = {
  user: null,
  orgId: null,
  csrfToken: null,
  authGen: 0,
  expiresAt: null,
};

export const workosAuthAtom = atom<WorkosAuthState>(workosAuthInitialState);
